import { useState } from "react";
import { ClipboardCopy, Check, Download, Megaphone, CalendarDays, Layers } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { getBusiness } from "@/data/business";
import { buildHandoffText, copyText, FOCUS } from "@/lib/handoff";

const ICONS = { marketing: Megaphone, eventi: CalendarDays, tutto: Layers };

export const HandoffButton = ({ build, chooser = false, className = "btn btn-ghost", label = "Copia per F&B W Management" }) => {
  const [done, setDone] = useState(false);
  const [open, setOpen] = useState(false);
  const text = (focus) => buildHandoffText(build(focus), getBusiness(), focus);

  const copy = async (focus = "tutto") => {
    const ok = await copyText(text(focus));
    setOpen(false);
    if (ok) {
      setDone(true);
      toast.success("Copiato: ora incollalo in F&B W Management");
      setTimeout(() => setDone(false), 2500);
    } else {
      toast.error("Copia non riuscita: usa il pulsante Scarica");
    }
  };

  const download = (focus = "tutto") => {
    const blob = new Blob([text(focus)], { type: "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `brief-fbw-${focus}-${new Date().toISOString().slice(0, 10)}.txt`;
    a.click();
    URL.revokeObjectURL(a.href);
    setOpen(false);
  };

  return (
    <span className="inline-flex no-print">
      <button className={`${className} !rounded-r-none`} onClick={() => (chooser ? setOpen(true) : copy())} data-testid="handoff-copy-btn">
        {done ? <Check size={18} /> : <ClipboardCopy size={18} />} {done ? "Copiato" : label}
      </button>
      <button className={`${className} !rounded-l-none !px-3 -ml-px`} onClick={() => (chooser ? setOpen(true) : download())} aria-label="Scarica il brief come file di testo" title="Scarica .txt" data-testid="handoff-download-btn">
        <Download size={16} />
      </button>
      {chooser && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="max-w-lg bg-[#FAF6F0] border-[#E3D5C3]" data-testid="handoff-dialog">
            <DialogHeader>
              <DialogTitle className="font-serif text-2xl text-[#2C221E]">Cosa vuoi passare a F&B W Management?</DialogTitle>
              <DialogDescription className="text-[#5C4D46]">Scegli il taglio del brief: lo copio negli appunti pronto da incollare.</DialogDescription>
            </DialogHeader>
            <div className="grid gap-3 mt-2">
              {FOCUS.map((f) => {
                const Icon = ICONS[f.id];
                return (
                  <div key={f.id} className="flex items-stretch gap-2">
                    <button className="choice flex-1 !min-h-[64px] text-left" onClick={() => copy(f.id)} data-testid={`handoff-focus-${f.id}`}>
                      <span className="choice-mark"><Icon size={16} /></span>
                      <span><span className="font-semibold block">{f.label}</span><span className="text-sm text-[#7A6B63]">{f.desc}</span></span>
                    </button>
                    <button className="btn btn-ghost !min-h-[64px] !px-3" onClick={() => download(f.id)} aria-label={`Scarica ${f.label}`} data-testid={`handoff-download-${f.id}`}><Download size={16} /></button>
                  </div>
                );
              })}
            </div>
          </DialogContent>
        </Dialog>
      )}
    </span>
  );
};
